import { useMemo } from "react";
import { StandardProductCategory } from "shared/api/middleware-api-client";
import { useStandardProductCategories } from "shared/api/hooks/useStandardProductCategories";

export const useSampleCategories = () => {
  const { standardProductCategories, categoriesLoading, isError, error } =
    useStandardProductCategories();

  const sampleCategories: StandardProductCategory[] = useMemo(() => {
    if (!standardProductCategories) return [];

    return standardProductCategories
      .map((cat) => ({
        ...cat,
        product: (cat.product ?? []).filter(
          (p) =>
            p.standardProduct.code !== "" &&
            p.standardProduct.productType.code ===
              "kleurstaalakoestischepanelen" &&
            p.standardProduct.disabled !== true,
        ),
      }))
      .filter((cat) => cat.product.length > 0);
  }, [standardProductCategories]);

  return {
    sampleCategories,
    isLoading: categoriesLoading,
    isError,
    error,
  };
};
